// extracted by css-extract-rspack-plugin
export default {"menuItem":"oHB5i","menuItemWithBorder":"s9KSg","menuItemStack":"BAKcp"};